import React from 'react'

import ModalFormBuilder from 'Skelet/src/components/ModalFormBuilder.js'

import config from '../config.js'


export default class extends React.Component {

  render() {
    return <ModalFormBuilder
      config = {config}
      shouldShow = {this.props.shouldShow}
      close = {this.props.close}
      fields = {[{type:"date", dbcol:"date", placeholder:"datum", maxLength:"10"},
        {type:"textarea", dbcol:"text", placeholder:"tekst", maxLength:"600", rows:7},
        {type:"hidden", dbcol:"id"}]}
      validate_fields = {[{dbcol:"date", name:"datum"}, {dbcol:"text", name:"tekst"}]}
      lettercounter="1"
      update_data = {this.props.update_data}
      api_method = "PATCH"
      api_endpoint = "/diary"
      api_block = "diary_update"
      api_block_clear = "diary_list"
      success_alert = "false"
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/ModalUpdateDiary.js